module.exports = __webpack_public_path__ + "e5399db3e9a89d0b54ba0b98040f0ba4.png";